/**
 * Organization Schema (JSON-LD)
 *
 * Defines LinkPool's brand identity for AI systems and search engines.
 * https://schema.org/Organization
 */

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'LinkPool',
  url: 'https://linkpool.com',
  logo: 'https://linkpool.com/brand-assets/linkpool-logo-white.png',
  description:
    "LinkPool is leading the crypto ecosystem's next evolution. Enterprise-grade Web3 infrastructure, liquid staking, and onchain finance solutions.",
  sameAs: [
    'https://twitter.com/linkpoolio',
    'https://x.com/linkpoolio',
    'https://github.com/linkpoolio'
  ],
  foundingDate: '2017-12-01',
  slogan: "Leading the crypto ecosystem's next evolution",
  knowsAbout: [
    'Web3',
    'Blockchain',
    'Liquid Staking',
    'Enterprise',
    'Decentralised',
    'Onchain Finance',
    'Chainlink',
    'DeFi'
  ]
}
